import { ICON_MAP_MARKER } from '@doveit/lego';
import { PlaceType } from '../../../services/place/place';
import { MAP_MARKER_RADIUS, HOME_CITY } from '../../themes/icons';

export const mapTypeToIcon: {
  [key in PlaceType]: string;
} = {
  PROVINCE: ICON_MAP_MARKER,
  LOCALITY: HOME_CITY,
  AREA: MAP_MARKER_RADIUS,
};

export const mapTypeToLabel: { [key in PlaceType]: string } = {
  PROVINCE: 'Provincia',
  LOCALITY: 'Comune',
  AREA: 'Quartiere',
};
